const AUDIT_FIELD_LABEL: Record<string, string> = {
  copied_from_id: "Disalin dari CPPT (ID sumber)",
  copied_edited: "Salinan diubah sebelum simpan",
  status: "Status",
  metode: "Metode verifikasi",
  pengirim_user_id: "Petugas pengantar (ID)",
  pengirim_nama: "Petugas pengantar",
  register_id: "No. register",
  pasien_rm: "No. RM",
  unit_tujuan_id: "Unit tujuan (kode)",
  unit_tujuan_nama: "Unit tujuan",
  unit_login_id: "Unit login petugas",
  arrived_at: "Waktu sampai",
  arrived_by_user_id: "Disahkan oleh (ID)",
  pickup_user_id: "Petugas penjemput (ID)",
  pickup_at: "Waktu dijemput",
  keterangan: "Keterangan"
};

const AUDIT_FIELD_BOOLEAN = ["copied_edited"];

const AUDIT_FIELD_VALUE_LABEL: Record<string, Record<string, string>> = {
  status: {
    berhasil: "Berhasil",
    gagal_pin: "Gagal — PIN pengantar salah",
    gagal_unit: "Gagal — unit login bukan unit tujuan"
  },
  metode: {
    pin_pengantar: "PIN/Password pengantar (dari komputer unit tujuan)",
    login_pengantar: "Konfirmasi pengantar sendiri (login di unit tujuan)"
  }
};

const AUDIT_ENTITY_LABEL: Record<string, string> = {
  "Models\\TransferInternal": "Transfer Internal"
};

export function auditEntityLabel(type: string): string {
  return AUDIT_ENTITY_LABEL[type] || type;
}

export function auditFieldLabel(key: string): string {
  return AUDIT_FIELD_LABEL[key] || key;
}

export function auditFieldValue(key: string, val: unknown): string {
  if (val === null || val === undefined || val === "") return "—";

  if (AUDIT_FIELD_BOOLEAN.indexOf(key) >= 0) {
    return val === true || val === 1 || val === "1" ? "Ya" : "Tidak";
  }

  const valueMap = AUDIT_FIELD_VALUE_LABEL[key];
  if (valueMap && typeof val === "string" && valueMap[val]) {
    return valueMap[val];
  }

  return typeof val === "object" ? JSON.stringify(val) : String(val);
}
